import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Season } from 'app/objects';
import { SeasonService } from '../../services/season.service';
import { LectionarySourceService, LectionarySource } from '../../services/lectionary-source.service';
import { FeastType, FeastTypeService } from '../../services/feast-type.service';

@Component({
  selector: 'app-service-search',
  templateUrl: './service-search.component.html',
  styleUrls: ['./service-search.component.css']
})
export class ServiceSearchComponent implements OnInit {

  @Output() searchItems = new EventEmitter<ServiceSearchModel>(); 
  public listsLoaded: boolean;
  public seasons: Season[];
  public lectionarySources: LectionarySource[]; 
  public feastTypes: FeastType[];

  public model: ServiceSearchModel;

  constructor(
    private seasonSvc: SeasonService,
    private lectionarySourceSvc: LectionarySourceService,
    private feastTypeSvc: FeastTypeService
    ) { }

  ngOnInit() {
    this.listsLoaded = false;
    this.model = new ServiceSearchModel();    
    this.getSearchValues();
  }

  public getSearchValues() {
  
    var seasonPromise = this.seasonSvc.loadEntites().then(
      (data) => {
        this.seasons = data;
      }
    )

    var lectionarySourcePromise = this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data.filter(s=> {return s.IsActive == true});
      }
    )
    
    var feastTypePromise = this.feastTypeSvc.loadEntites().then(
      (data) => {
        this.feastTypes = data;
      }
    )
  
    Promise.all([seasonPromise, lectionarySourcePromise]).then(
      (data) => { 
        console.log("All promises are completed");
        this.listsLoaded = true;
        this.getSavedModel();
      }
    )

  }

  public getSavedModel() {
    var savedModel = localStorage["serviceSeach"];
    console.log("getSavedModel", savedModel);
    if (savedModel != undefined) {
      this.model = JSON.parse(savedModel);
      console.log("parsedModel", this.model);
      this.search();
    }
  }
 
  public search() {
    console.log("Emitting search event from service search component", this.model);
    localStorage["serviceSeach"] = JSON.stringify(this.model);
    this.searchItems.emit(this.model); 
  }

}
 
export class ServiceSearchModel {
  public seasonId: number;
  public lectionarySourceId: number;
  public feastTypeId: number;
}
